/**
 * @type {Object}
 */
const EntityTypeIdentifiers = {
  MENTION: "MENTION",
  LINK: "LINK",
};

export default EntityTypeIdentifiers;
